// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d0ccs","top":"styles_top__2bWp5","left":"styles_left__29bpi","description":"styles_description__3bT_k"};